import React from 'react'

const Footer = () => {
    return (
        <footer>
            <p>Created by Evann Wu</p>
        </footer>
    )
}

export default Footer